/**
 * Auto-generated from Swagger/OpenAPI.
 * Do not edit manually.
 */

export const ApiUrlTemplate = {
    "Case_CreateCase": "/api/cases",
    "Case_CreateFaq": "/api/cases/{caseId}/faq",
    "Case_DeleteFaqById": "/api/cases/{caseId}/faq/{faqId}",
    "Case_GetCaseById": "/api/cases/{id}",
    "Case_GetCaseClientsFormColumns": "/api/cases/{id}/clients-form-columns",
    "Case_GetCaseRoleForUser": "/api/cases/{caseId}/case-roles/{userId}",
    "Case_GetCaseRoles": "/api/cases/{caseId}/case-roles",
    "Case_GetCases": "/api/cases",
    "Case_GetCasesAndRoles": "/api/cases/cases-with-roles",
    "Case_GetClientsFormDetailsById": "/api/cases/public/{caseId}/clients-form",
    "Case_GetFaqsById": "/api/cases/{caseId}/faq",
    "Case_GetFormBackgroundUrl": "/api/cases/public/{caseId}/form-background-url",
    "Case_GetPublicCases": "/api/cases/public",
    "Case_GetSimpleCaseDetails": "/api/cases/simple",
    "Case_GetUsedCaseIds": "/api/cases/used-case-id",
    "Case_SendCaseAccessRequest": "/api/cases/{caseId}/access-request",
    "Case_UpdateCaseDetails": "/api/cases/{id}",
    "Case_UpdateFaqById": "/api/cases/{caseId}/faq/{faqId}",
    "Case_UpdateFaqOrder": "/api/cases/{caseId}/faq/order",
    "Case_UpsertClientsFormForCaseId": "/api/cases/{caseId}/clients-form",
    "CaseDashboard_GetCaseRolesForCaseDashboard": "/api/case/{caseId}/dashboard/case-roles",
    "CaseDashboard_GetClaimsForCaseDashboard": "/api/case/{caseId}/dashboard/claims",
    "CaseDashboard_GetClaimTemplateForCaseDashboard": "/api/case/{caseId}/dashboard/claim-templates",
    "CaseDashboard_GetClientInvitesStatisticsByCase": "/api/case/{caseId}/dashboard/case-invites",
    "CaseDashboard_GetClientsForCaseDashboard": "/api/case/{caseId}/dashboard/clients",
    "CaseDashboard_GetContractsForCaseDashboard": "/api/case/{caseId}/dashboard/contracts",
    "Claim_ApproveClaim": "/api/claim/{claimId}/approve",
    "Claim_CreateClaim": "/api/claim",
    "Claim_DeleteClaim": "/api/claim/{claimId}",
    "Claim_GetClaimDetail": "/api/claim/{claimId}",
    "Claim_GetClaimsByCase": "/api/claim/case/{caseId}",
    "Claim_GetClaimsByClientProfile": "/api/claim/profile/{clientProfileId}",
    "Claim_GetEvidenceIntroForCase": "/api/claim/{caseId}/evidence-intro",
    "Claim_RejectClaim": "/api/claim/{claimId}/reject",
    "Claim_UpdateClaim": "/api/claim",
    "Claim_UpdateEvidenceIntroForCase": "/api/claim/{caseId}/evidence-intro",
    "ClaimAttribute_CreateClaimAttribute": "/api/claim-attribute",
    "ClaimAttribute_DeleteClaimTemplateAttribute": "/api/claim-attribute/{attributeId}",
    "ClaimAttribute_GetClaimAttributesByClaimId": "/api/claim-attribute/claim/{claimId}",
    "ClaimAttribute_GetClaimAttributesByTemplateId": "/api/claim-attribute/template/{templateId}",
    "ClaimAttribute_UpdateClaimAttributeTemplate": "/api/claim-attribute",
    "ClaimAttributeValue_DeleteClaimAttributeValues": "/api/claim-attribute-value/{attributeValueId}",
    "ClaimAttributeValue_ListClaimAttributeValuesByClaimId": "/api/claim-attribute-value/{claimId}",
    "ClaimAttributeValue_UpsertClaimAttributeValues": "/api/claim-attribute-value",
    "ClaimDocument_CreateClaimDocument": "/api/claim-documents",
    "ClaimDocument_DeleteClaimDocument": "/api/claim-documents/{documentId}",
    "ClaimDocument_GetClaimDocument": "/api/claim-documents/{documentId}",
    "ClaimDocument_ListClaimDocumentsByClaimId": "/api/claim-documents/claim/{claimId}",
    "ClaimDocument_UpdateClaimDocument": "/api/claim-documents",
    "ClaimTemplate_CreateClaimTemplate": "/api/claim-template",
    "ClaimTemplate_DeleteClaimTemplate": "/api/claim-template/{templateId}",
    "ClaimTemplate_GetClaimTemplate": "/api/claim-template/{templateId}",
    "ClaimTemplate_ListClaimTemplatesForCase": "/api/claim-template/case/{caseId}",
    "ClaimTemplate_UpdateClaimTemplate": "/api/claim-template",
    "Client_BulkProcessColumns": "/api/clients/profiles/bulk/{caseId}/extra-columns",
    "Client_BulkProcessProfiles": "/api/clients/profiles/bulk/{caseId}",
    "Client_ConfirmClientProfile": "/api/clients/profile/{clientId}/confirmation",
    "Client_CreateFinalApproval": "/api/clients/profile/{profileId}/provide-approval",
    "Client_CreateFinalApprovalRequest": "/api/clients/profile/{profileId}/request-approval",
    "Client_EditTotalRevenue": "/api/clients/{clientId}/case/{caseId}/total-revenue",
    "Client_GetClientDetail": "/api/clients/profile/{clientId}",
    "Client_GetClientProfiles": "/api/clients/profiles",
    "Client_GetClients": "/api/clients/case/{caseId}",
    "Client_GetDynamicClientDetail": "/api/clients/case/{caseId}/client/{clientId}/dynamic-client-data",
    "Client_GetPlatformClientDetail": "/api/clients/case/{caseId}/client/{clientId}/client-data",
    "Client_RejectClientProfile": "/api/clients/profile/{clientId}/rejection",
    "Client_UpdateAllEvidenceUploaded": "/api/clients/profile/{profileId}/all-evidence-uploaded",
    "Client_UpdateClientConfirmation": "/api/clients/profile/{profileId}/client-confirmation",
    "Client_UpdateClientProfile": "/api/clients/profile/{profileId}",
    "Client_UpdateClientProfilesEligibility": "/api/clients/profiles/eligibility",
    "ClientRegistration_BulkCreateClient": "/api/client-registrations/case/{caseId}/registration/bulk",
    "ClientRegistration_CreateClient": "/api/client-registrations/case/{caseId}/registration",
    "ClientRegistration_CreateClientInvite": "/api/client-registrations/client-invite/{caseId}",
    "ClientRegistration_CreateClientPublic": "/api/client-registrations/public/case/{caseId}/registration",
    "ClientRegistration_CreateClientUser": "/api/client-registrations/public/client",
    "ClientRegistration_GetClientInvite": "/api/client-registrations/client-invite/{clientInviteId}",
    "ClientRegistration_GetClientInvites": "/api/client-registrations/client-invite/case/{caseId}",
    "ClientRegistration_GetRegistrationLandingData": "/api/client-registrations/public/landing/{inviteCode}",
    "Contract_ChangeContractStatus": "/api/contract/profile/{clientProfileId}/change-status",
    "Contract_CreateContractTemplate": "/api/contract",
    "Contract_GetContractData": "/api/contract/{contractId}/data",
    "Contract_GetContractInfo": "/api/contract/{contractId}/info",
    "Contract_GetContractTemplatesOfCase": "/api/contract/case/{clientCaseId}",
    "Contract_UpdateContractTemplate": "/api/contract",
    "ContractGroup_CreateContractTemplate": "/api/contractgroup",
    "ContractGroup_DeleteContractGroup": "/api/contractgroup/{id}",
    "ContractGroup_GetContractTemplatesOfCase": "/api/contractgroup/case/{caseId}",
    "ContractGroup_UpdateContractTemplate": "/api/contractgroup",
    "ContractTemplate_CreateContractTemplate": "/api/contracttemplate",
    "ContractTemplate_DeleteContractTemplate": "/api/contracttemplate/{id}",
    "ContractTemplate_EditClaimTemplate": "/api/contracttemplate/{id}/edit",
    "ContractTemplate_GetContractIntroForCase": "/api/contracttemplate/{caseId}/contract-intro",
    "ContractTemplate_GetContractTemplateData": "/api/contracttemplate/{contractTemplateId}/data",
    "ContractTemplate_GetContractTemplateInfo": "/api/contracttemplate/{contractTemplateId}/info",
    "ContractTemplate_GetContractTemplatesOfCase": "/api/contracttemplate/case/{caseId}",
    "ContractTemplate_UpdateContractIntroForCase": "/api/contracttemplate/{caseId}/contract-intro",
    "Emailing_GetSentEmailLogDetail": "/api/emailing/sent-emails/{logId}",
    "Emailing_GetSentEmails": "/api/emailing/sent-emails",
    "Emailing_SendEmail": "/api/emailing/sent-emails",
    "EmailTemplate_CreateEmptyEmailTemplateDetails": "/api/email-template/{caseId}/create-template/{emailGroup}",
    "EmailTemplate_GetTemplateDetail": "/api/email-template/{id}/detail",
    "EmailTemplate_GetTemplateListByCaseId": "/api/email-template/{caseId}",
    "EmailTemplate_UpdateEmailTemplateDetails": "/api/email-template/edit-template",
    "EvidenceDocument_CreateEvidenceDocuments": "/api/evidence-documents/profile/{clientProfileId}",
    "EvidenceDocument_GetEvidenceDocument": "/api/evidence-documents/{documentId}",
    "EvidenceDocument_GetEvidenceDocumentsByCase": "/api/evidence-documents/case/{caseId}",
    "EvidenceDocument_GetEvidenceDocumentsByProfile": "/api/evidence-documents",
    "EvidenceDocument_UpdateEvidenceDocument": "/api/evidence-documents/{documentId}",
    "Exports_CreateClientsExport": "/api/exports/clients",
    "Exports_DownloadExport": "/api/exports/{id}/download",
    "Exports_GetExports": "/api/exports",
    "Health_AuthCheck": "/api/health/auth",
    "Health_HealthCheck": "/api/health",
    "Localization_GetDefaultCountry": "/api/localization/public/country/default",
    "Localization_GetDefaultLanguage": "/api/localization/public/language/default",
    "Localization_GetLocalizedCountries": "/api/localization/public/countries",
    "Notifications_DeleteMyNotificationLog": "/api/notifications/my-logs/{id}",
    "Notifications_GetMyNotificationLog": "/api/notifications/my-logs/{id}",
    "Notifications_GetMyNotificationLogs": "/api/notifications/my-logs",
    "Notifications_GetMyNotificationLogsCount": "/api/notifications/my-logs/count",
    "Notifications_MarkMyNotificationLogAsRead": "/api/notifications/my-logs/{id}/mark-as-read",
    "Notifications_Run": "/api/notifications/{id}/run",
    "Ocr_WebhookNotify": "/api/ocr",
    "PlatformLogging_ListCaseLogs": "/api/platform-logging/case/{id}",
    "PlatformLogging_ListGlobalLogs": "/api/platform-logging",
    "PlatformUser_DeleteUserCaseRole": "/api/platform-users/{userId}/case-roles/{caseId}",
    "PlatformUser_GetUser": "/api/platform-users/{userId}",
    "PlatformUser_GetUserCaseRoles": "/api/platform-users/{userId}/case-roles",
    "PlatformUser_ListCaseAssignableUsers": "/api/platform-users/assignable",
    "PlatformUser_ListUnassignedUsers": "/api/platform-users/unassigned",
    "PlatformUser_ListUsers": "/api/platform-users",
    "PlatformUser_SyncUsers": "/api/platform-users/sync",
    "PlatformUser_UpdateUserCaseRole": "/api/platform-users/{userId}/case-roles",
    "PlatformUser_UpdateUserRole": "/api/platform-users/{userId}/platform-role",
    "ReviewMessage_CreateClaimReviewMessage": "/api/review-messages/claim/{claimId}",
    "ReviewMessage_CreateContractReviewMessage": "/api/review-messages/profile/{contractId}",
    "ReviewMessage_GetClaimReviewMessageById": "/api/review-messages/{reviewMessageId}",
    "ReviewMessage_GetClaimReviewMessages": "/api/review-messages/claim/{claimId}",
    "ReviewMessage_GetClaimReviewMessagesPerClientCase": "/api/review-messages/profile/{clientProfileId}/claims",
    "ReviewMessage_GetContractReviewMessages": "/api/review-messages/profile/{clientProfileId}",
    "ReviewMessage_GetReviewMessages": "/api/review-messages/profile/messages",
    "ReviewMessage_UpdateReviewMessage": "/api/review-messages",
    "SendGridConfiguration_CreateContactList": "/api/sendgrid-configuration/contactlist",
    "SendGridConfiguration_CreateSendGridTemplate": "/api/sendgrid-configuration/templates",
    "SendGridConfiguration_DeleteSendGridList": "/api/sendgrid-configuration/contactlist/{id}",
    "SendGridConfiguration_DeleteSendGridTemplateById": "/api/sendgrid-configuration/templates/{id}",
    "SendGridConfiguration_GetSendGridContactList": "/api/sendgrid-configuration/contactlist",
    "SendGridConfiguration_GetSendGridTemplates": "/api/sendgrid-configuration/templates",
    "SendGridConfiguration_UpdateSendGridContactList": "/api/sendgrid-configuration/contactlist/{id}",
    "SendGridConfiguration_UpdateSendGridTemplate": "/api/sendgrid-configuration/templates/{id}",
    "Support_SendSupportMessage": "/api/support",
} as const;

export type ApiUrlTemplateKey = keyof typeof ApiUrlTemplate;
export type ApiUrlTemplateValue = (typeof ApiUrlTemplate)[ApiUrlTemplateKey];
